import React from "react"

const IconHealth = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" fill="none" viewBox="0 0 33 33">
      <path
        fill="#ED4C5C"
        d="M12.375 20.51v.802a6.187 6.187 0 0012.375 0v-2.296a4.126 4.126 0 112.75 0v2.297a8.938 8.938 0 11-17.875 0v-.802a8.25 8.25 0 01-6.875-8.136V5.5A2.75 2.75 0 015.5 2.75h1.375a1.375 1.375 0 010 2.75H5.5v6.875a5.5 5.5 0 0011 0V5.5h-1.375a1.375 1.375 0 010-2.75H16.5a2.75 2.75 0 012.75 2.75v6.875a8.25 8.25 0 01-6.875 8.136zm13.75-4.01a1.375 1.375 0 100-2.75 1.375 1.375 0 000 2.75z"
      ></path>
    </svg>
  )
}

export default IconHealth
